//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { connect } from 'react-redux';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//ateq
import OrderDetails from "components/OrderDetails/OrderDetails.jsx";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

function timeConverter(UNIX_timestamp){
  var a = new Date(UNIX_timestamp * 1000);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var time = month + ' ' + date + ' ' + year + ' ' + hour + ':' + min;
  return time;
}

class OrdersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      moreRows: false
    }

    this.refreshOrders = this.refreshOrders.bind(this);
  }

  componentDidMount() {
    this.refreshOrders();
  }

  orderChanged(order) {

    var orders = this.state.orders;
    for(var i = 0; i < orders.length; i++) {
      if(orders[i].id === order.id) {
        orders[i] = order;
        break;
      }
    }
    this.setState({orders:orders});
  }

  refreshOrders() {

    var modified = 0;
    if(this.state.orders.length > 0)
      modified = this.state.orders[this.state.orders.length - 1].modified;

    db.getRecentOrders(modified).then(orders => {

      var p1 = [];
      
      for(var i = 0; i < orders.length; i++) {

        if(!orders[i].status) {
          orders[i].status = 'NEW';
        }

        p1.push(db.getSchool(orders[i].schoolID));
        
        var orderTotal = 0.0;
        for(var o = 0; o < orders[i].items.length; o++) {

          var qty = 1;
          if(orders[i].items[o].qty)
            qty = orders[i].items[o].qty;
          else //temp for test orders
            orders[i].items[o].qty = 1;

          orders[i].items[o].listPrice = Number(orders[i].items[o].listPrice).toFixed(2);

          orders[i].items[o].total = Number(orders[i].items[o].listPrice * qty).toFixed(2);
          orderTotal = orderTotal + (orders[i].items[o].listPrice * qty);
        }

        if(orders[i].tax)
          orderTotal = orderTotal + Number(orders[i].tax);

        orders[i].orderTotal = orderTotal.toFixed(2);
        orders[i].orderPlaced = timeConverter(orders[i].modified);
      }

      Promise.all(p1).then((dbResults) => {
        
        for(var j = 0; j < dbResults.length; j++) {
          for(var k = 0; k < orders.length; k++) {
            if(dbResults[j].id === orders[k].schoolID) {
              orders[k].school = dbResults[j];
            }
          }
        }

        var loadedOrders = this.state.orders;
        for(var i = 0; i < orders.length; i++)
          loadedOrders.push(orders[i]);

        this.setState({orders:loadedOrders});

        if(orders.length < 20)
          this.setState({moreRows: false});
        else 
          this.setState({moreRows: true});

      });
    }); 
  }

  trim(value, maxLength) {
    if(value) {
        if(value.length > maxLength)
            return value.substring(0,maxLength) + "...";
        else
            return value;
    } else return "";
  }

  pad(value) {
    if (value < 10) {
        return '0' + value;
    } else {
        return value;
    }
  }

  showLoadMore() {
    if(this.state.moreRows) {
      return "block";
    } else {
      return "none";
    }
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
            <GridContainer>
                <GridItem xs={12} sm={12} >
                  <h4 className={classes.cardTitleWhite}>Orders</h4>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
              <GridItem xs={12}>
                <br />
                <Table className={classes.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{padding:"4px", width:"54px"}}> 

                      </TableCell>
                      <TableCell style={{padding:"4px"}}> 
                        Date
                      </TableCell>
                      <TableCell style={{padding:"4px"}}> 
                        Status
                      </TableCell>
                      <TableCell style={{padding:"4px"}}> 
                        School
                      </TableCell>
                      <TableCell style={{padding:"4px"}}> 
                        PO #
                      </TableCell>
                      <TableCell style={{padding:"4px", textAlign:"right"}}> 
                        Total
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.orders.map(value => (
                      <TableRow key={value.id} className={classes.tableRow} >
                        <TableCell className={classes.tableActions} style={{padding:"4px", width:"54px"}}> 
                          <Tooltip id="tooltip-top" title="Edit Order" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <OrderDetails order={value} orderChanged={() => this.orderChanged(value)} />
                          </Tooltip>
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"4px"}}> 
                          {value.orderPlaced}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"4px"}}> 
                          {value.status}
                        </TableCell>
                        <TableCell className={classes.tableCell} style={{padding:"4px"}}> 
                          {value.school.Name}
                        </TableCell>
                        <TableCell className={classes.tableActions} style={{padding:"4px"}}>  
                          {value.poNumber}
                        </TableCell>
                        <TableCell className={classes.tableActions} style={{padding:"4px", textAlign:"right"}}>  
                          ${value.orderTotal}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <br />
                <div style={{textAlign:"center", cursor:"pointer", display:this.showLoadMore()}} onClick={this.refreshOrders} >
                  Load More
                </div>
              </GridItem>
            </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}

OrdersList = connect(mapStateToProps)(OrdersList);
export default withStyles(styles)(OrdersList);



// WEBPACK FOOTER //
// ./src/views/OrdersList/OrdersList.jsx